<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="设备类型:" prop="deviceType">
          <Select
            v-model="formFields.deviceType"
            clearable
            filterable
            placeholder="请选择设备类型..."
            size="small"
          >
            <Option v-for="deviceType in deviceTypeEnum" :key="deviceType.value" :value="deviceType.value" :label="deviceType.label" />
          </Select>
        </FormItem>
        <FormItem label="设备进出:" prop="deviceInOut">
          <Select
            v-model="formFields.deviceInOut"
            clearable
            filterable
            placeholder="请选择设备进出..."
            size="small"
          >
            <Option v-for="deviceInOut in deviceInOutEnum" :key="deviceInOut.value" :value="deviceInOut.value" :label="deviceInOut.label" />
          </Select>
        </FormItem>
        <FormItem label="设备标识:" prop="label">
          <Input v-model="formFields.label" placeholder="请输入设备标识..." size="small" />
        </FormItem>
        <FormItem label="是否启用:" prop="status">
          <RadioGroup v-model="formFields.status">
            <Radio :label="1" :true-value="1">
              启用
            </Radio>
            <Radio :label="0" :true-value="0">
              不启用
            </Radio>
          </RadioGroup>
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary" :disabled="loadingStatus" size="small" icon="ios-checkmark-circle-outline" :loading="submit" @click="saveOrUpdate">
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { applyObject } from '@/utils/util'
export default {
  name: 'ParkingAgentDeviceDialog',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    agentId: {
      type: Number,
      default: 0
    },
    parkingId: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      formFields: {
        label: '',
        deviceType: '',
        deviceInOut: '',
        status: 1,
        id: this.id,
        parkingId: this.parkingId,
        agentId: this.agentId
      },

      ruleValidate: {
        deviceType: [
          { required: true, message: '设备类型不能为空!' }
        ],
        deviceInOut: [
          { required: true, message: '设备进出不能为空!' }
        ]
      }
    }
  },
  computed: {
    deviceTypeEnum() {
      return this.$config.deviceTypes
    },
    deviceInOutEnum() {
      return this.$config.deviceEntryTypes
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑终端设备' : '添加终端设备'
      }
    },
    action() {
      return this.$config.apiContextPath + '/parking/' + this.parkingId + '/agent/' + this.agentId + '/device'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          // this.formFields = res.data
          applyObject(res.data, this.formFields)
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
      this.formFields.parkingId = 0
      this.formFields.agentId = 0
    },
    saveOrUpdate: function() {
      if (this.action) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submit = true
            const isNew = this.formFields.id === 0
            this.formFields.parkingId = this.parkingId
            this.formFields.agentId = this.agentId
            request({
              url: this.action + (isNew ? '' : ('/' + this.id)),
              method: isNew ? 'POST' : 'PUT',
              data: this.formFields
            }).then(res => {
              this.loadingStatus = false
              this.formFields = res.data
              this.$Notice.success({
                title: '数据保存成功',
                desc: '终端设备 `' + this.formFields.label + '` 保存成功!'
              })
              this.submit = false
              this.closeModal(true)
            }).catch(() => {
              // this.$Notice.error({
              //   title: '服务器数据请求失败',
              //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
              // })
              this.loadingStatus = false
              this.submit = false
            })
          }
        })
      }
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>
